import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { useCalculator } from "Order/Hooks/useCalculator";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import { toast } from "sonner";

type CalculatorCardWidgetProps = {
	order: OrderDetailResponseDto;
};

export function CalculatorCardWidget({ order }: CalculatorCardWidgetProps) {
	const { data, isFetching, refetch } = useCalculator(order.id);

	const handleCalculate = async () => {
		const { isSuccess } = await refetch();
		if (isSuccess) {
			toast.success("Price calculated successfully");
		}
	};

	return (
		<BaseCard title="Price Details">
			<Box display="flex" flexDirection="column" gap={2}>
				<Tooltip
					title={
						data ? (
							<pre
								style={{
									margin: 0,
									fontFamily: "monospace",
									fontSize: "12px",
									color: "black",
								}}
							>
								{JSON.stringify(data, null, 2)}
							</pre>
						) : (
							"No breakdown available"
						)
					}
					arrow
					placement="right"
					sx={{ maxWidth: "500px", background: "black" }}
				>
					<Typography
						variant="h5"
						sx={{ cursor: "pointer", display: "inline-block" }}
					>
						{data ? Math.round(data.total) : 0}
					</Typography>
				</Tooltip>
				<Button
					variant="contained"
					loading={isFetching}
					onClick={handleCalculate}
				>
					Calculate
				</Button>
			</Box>
		</BaseCard>
	);
}
